import HeaderMenuHtml from "./HeaderMenuHtml.js";

export default class HeaderMenuCmp {
    /** @type {HeaderMenuHtml} */
    #html = new HeaderMenuHtml();

    /** @param {HTMLElement} parent */
    init(parent) {
        this.#html.init(parent);
    }
}